import { lazy } from 'react'
import { Redirect, Route as RouterRoute, Switch } from 'react-router-dom'

import { NOT_AUTHENTICATED_ROUTES, ROUTE_PATHS } from '@/routes/routes.constants'

import Layout from '../components/layout'

import Route from './route'

// const {
// REACT_APP_AUTH_PUBLIC_URL,
// } = process.env;

const Grids = lazy(() => import('./grids'))
const Users = lazy(() => import('./users'))
const InviteRegister = lazy(() => import('./invite-register'))
const RetrievePassword = lazy(() => import('./retrieve-password'))
const Grid = lazy(() => import('./grid'))
const Login = lazy(() => import('./login'))
const DeeplTest = lazy(() => import('./deepl-test'))
// const Autoconnect = lazy(() => import('./autoconnect'));

function Routes(props = {}) {
  return (
    <Switch>
      {/* Routes without layout */}
      {/* <Route exact path={ROUTES.LOGOUT} component={Logout} extraProps={{ ...props, redirect: REACT_APP_AUTH_PUBLIC_URL }} /> */}
      <Route exact path={NOT_AUTHENTICATED_ROUTES.LOGIN} component={Login} />
      <Route exact path={NOT_AUTHENTICATED_ROUTES.INVITE_REGISTER} component={InviteRegister} />
      <Route exact path={NOT_AUTHENTICATED_ROUTES.RETRIEVE_PASSWORD} component={RetrievePassword} />
      {/* <Route exact path={NOT_AUTHENTICATED_ROUTES.AUTOCONNECT} component={Autoconnect} /> */}

      <RouterRoute>
        <Layout>
          <Switch>
            <Route exact path={ROUTE_PATHS.GRIDS} component={Grids} extraProps={props} />
            <Route exact path={ROUTE_PATHS.USERS} component={Users} extraProps={props} />
            <Route exact path={ROUTE_PATHS.GRID} component={Grid} extraProps={props} />
            <Route exact path={ROUTE_PATHS.DEEPL_TEST} component={DeeplTest} extraProps={props} />

            {/* <Route component={NotFound} /> */}
            <Redirect to={ROUTE_PATHS.GRIDS} />
          </Switch>
        </Layout>
      </RouterRoute>
    </Switch>
  )
}

export default Routes
